import Vue from "vue";
import Router from "vue-router";
import http from "@/utils/request";
import { clearLoginInfo } from "@/utils";
import { isURL } from "@/utils/validate";
import { Message } from "element-ui";

Vue.use(Router);
// 开发环境不使用懒加载, 因为懒加载页面太多的话会造成webpack热更新太慢, 所以只有生产环境使用懒加载
const _import = require("./import-" + "development");
// const _import = require('./import-' + process.env.NODE_ENV)F
// console.log("_import", _import)
let tmp = _import("operatelog");
// console.log("tmp", tmp)

// 全局路由(无需嵌套上左右整体布局)
const globalRoutes = [
  {
    path: "/404",
    component: _import("common/404"),
    name: "404",
    meta: { title: "404未找到" }
  },
  {
    path: "/login",
    component: _import("common/Login"),
    name: "login",
    meta: { title: "登录" }
  }
];

const mainRoutes = {
  path: "/",
  component: _import("common/Home"),
  name: "main",
  // redirect: { name: 'home' },
  meta: { title: "主入口整体布局" },
  // redirect: "/welcome",
  children: [
    {
      path: "/welcome",
      component: _import("common/Welcome"),
      name: "welcome",
      meta: { title: "欢迎" }
    }
  ],
  beforeEnter(to, from, next) {
    // debugger;
    let token = sessionStorage.getItem("token");
    if (!token || !/\S/.test(token)) {
      clearLoginInfo();
      router.options.isAddDynamicMenuRoutes = false;

      next({ name: "login" });
    }
    next();
  }
};

const router = new Router({
  mode: "hash",
  scrollBehavior: () => ({ y: 0 }),
  isAddDynamicMenuRoutes: false, // 是否已经添加动态(菜单)路由
  routes: globalRoutes.concat(mainRoutes)
});

router.beforeEach(async (to, from, next) => {
  // 添加动态(菜单)路由
  // 1. 已经添加 or 全局路由, 直接访问
  // 2. 获取菜单列表, 添加并保存本地存储
  // debugger;
  // console.log("router.options.isAddDynamicMenuRoutes", router.options.isAddDynamicMenuRoutes)
  // console.log("fnCurrentRouteType(to, globalRoutes)", fnCurrentRouteType(to, globalRoutes))
  let token = sessionStorage.getItem("token");
  if (!token || !/\S/.test(token)) {
    clearLoginInfo();
    router.options.isAddDynamicMenuRoutes = false;
    // next({ name: 'login' })
  }

  if (
    router.options.isAddDynamicMenuRoutes ||
    fnCurrentRouteType(to, globalRoutes) === "global"
  ) {
    next();
  } else {
    let res;
    try {
      let data = await http.post("menus").catch(error => {
        // Message.error(error.response.data.message)
        console.log(error.response.data.message);
      });
      // console.log("data", data)
      res = data.data;

      if (res.meta.status === 200) {
        if (sessionStorage.getItem("loginSts")) {
          Message.success({
            message: "登陆成功",
            offset: 61
          });
          sessionStorage.removeItem("loginSts");
        }
        
        // res.data.unshift({
        //   children: [
        //     {
        //       floder: 'F',
        //       id: 10,
        //       menuIcon: 'icon-user',
        //       menuRoute: '/vbrand',
        //       menuTitle: '品牌管理',
        //       menuTitleEn: 'vbrand',
        //       menu_actions: [],
        //       order: 0,
        //       parentId: 0,
        //       roleType: '1',
        //       routeName: 'voc.vbrand',
        //       showFlag: 'T'
        //     },
        //     {
        //       floder: 'F',
        //       id: 11,
        //       menuIcon: 'icon-user',
        //       menuRoute: '/goods',
        //       menuTitle: '商品管理',
        //       menuTitleEn: 'goods',
        //       menu_actions: [],
        //       order: 0,
        //       parentId: 0,
        //       roleType: '1',
        //       routeName: 'voc.goods',
        //       showFlag: 'T'
        //     },
        //     {
        //       floder: 'F',
        //       id: 12,
        //       menuIcon: 'icon-user',
        //       menuRoute: '/clas',
        //       menuTitle: '分类管理',
        //       menuTitleEn: 'clas',
        //       menu_actions: [],
        //       order: 0,
        //       parentId: 0,
        //       roleType: '1',
        //       routeName: 'voc.clas',
        //       showFlag: 'T'
        //     },
        //     {
        //       floder: 'F',
        //       id: 13,
        //       menuIcon: 'icon-user',
        //       menuRoute: '/pdimen',
        //       menuTitle: '商品维度管理',
        //       menuTitleEn: 'pdimen',
        //       menu_actions: [],
        //       order: 0,
        //       parentId: 0,
        //       roleType: '1',
        //       routeName: 'voc.pdimen',
        //       showFlag: 'T'
        //     },
        //     {
        //       floder: 'F',
        //       id: 14,
        //       menuIcon: 'icon-user',
        //       menuRoute: '/pattrt',
        //       menuTitle: '商品属性管理',
        //       menuTitleEn: 'pattrt',
        //       menu_actions: [],
        //       order: 0,
        //       parentId: 0,
        //       roleType: '1',
        //       routeName: 'voc.pattrt',
        //       showFlag: 'T'
        //     },
        //     {
        //       floder: 'F',
        //       id: 15,
        //       menuIcon: 'icon-user',
        //       menuRoute: '/charaword',
        //       menuTitle: '特征词库管理',
        //       menuTitleEn: 'charaword',
        //       menu_actions: [],
        //       order: 0,
        //       parentId: 0,
        //       roleType: '1',
        //       routeName: 'voc.charaword',
        //       showFlag: 'T'
        //     },
        //     {
        //       floder: 'F',
        //       id: 16,
        //       menuIcon: 'icon-user',
        //       menuRoute: '/evalword',
        //       menuTitle: '评价关键词管理',
        //       menuTitleEn: 'evalword',
        //       menu_actions: [],
        //       order: 0,
        //       parentId: 0,
        //       roleType: '1',
        //       routeName: 'voc.evalword',
        //       showFlag: 'T'
        //     },
        //     {
        //       floder: 'F',
        //       id: 17,
        //       menuIcon: 'icon-user',
        //       menuRoute: '/adverb',
        //       menuTitle: '评价副词管理',
        //       menuTitleEn: 'adverb',
        //       menu_actions: [],
        //       order: 0,
        //       parentId: 0,
        //       roleType: '1',
        //       routeName: 'voc.adverb',
        //       showFlag: 'T'
        //     },
        //     {
        //       floder: 'F',
        //       id: 18,
        //       menuIcon: 'icon-user',
        //       menuRoute: '/cmetanalys',
        //       menuTitle: '评论分析',
        //       menuTitleEn: 'cmetanalys',
        //       menu_actions: [],
        //       order: 0,
        //       parentId: 0,
        //       roleType: '1',
        //       routeName: 'voc.cmetanalys',
        //       showFlag: 'T'
        //     },
        //     {
        //       floder: 'F',
        //       id: 19,
        //       menuIcon: 'icon-user',
        //       menuRoute: '/cmetcontent',
        //       menuTitle: '评论内容',
        //       menuTitleEn: 'cmetcontent',
        //       menu_actions: [],
        //       order: 0,
        //       parentId: 0,
        //       roleType: '1',
        //       routeName: 'voc.cmetcontent',
        //       showFlag: 'T'
        //     },
        //     {
        //       floder: 'F',
        //       id: 20,
        //       menuIcon: 'icon-user',
        //       menuRoute: '/wordmouth',
        //       menuTitle: '口碑评价',
        //       menuTitleEn: 'wordmouth',
        //       menu_actions: [],
        //       order: 0,
        //       parentId: 0,
        //       roleType: '1',
        //       routeName: 'voc.wordmouth',
        //       showFlag: 'T'
        //     }
        //   ],
        //   floder: 'T',
        //   id: 0,
        //   menuIcon: 'icon-user',
        //   menuRoute: '/voc',
        //   menuTitle: 'VOC',
        //   menuTitleEn: 'voc',
        //   menu_actions: [],
        //   order: 0,
        //   parentId: 0,
        //   roleType: null,
        //   routeName: 'voc',
        //   showFlag: 'T'
        // })

        // this.$message.error(res.meta.msg);
        sessionStorage.setItem("menulist", JSON.stringify(res.data));

        router.options.isAddDynamicMenuRoutes = true;
        fnAddDynamicMenuRoutes(res.data);
        // debugger;
        next({ ...to, replace: true });
      } else {
        sessionStorage.setItem("menuList", "[]");
        console.log(
          `%c${e} 请求菜单列表和权限失败，跳转至登录页！！`,
          "color:blue"
        );
        router.push({ name: "login" });
        // next()
      }
    } catch (e) {
      // console.info("get menu error", e)
      next({ name: "login" });
    }
    // console.log("router.beforeEach get menu data", res)
    // debugger;
  }
});

/**
 * 判断当前路由类型, global: 全局路由, main: 主入口路由
 * @param {*} route 当前路由
 */
function fnCurrentRouteType(route, globalRoutes = []) {
  var temp = [];
  for (var i = 0; i < globalRoutes.length; i++) {
    if (route.path === globalRoutes[i].path) {
      return "global";
    } else if (
      globalRoutes[i].children &&
      globalRoutes[i].children.length >= 1
    ) {
      temp = temp.concat(globalRoutes[i].children);
    }
  }
  return temp.length >= 1 ? fnCurrentRouteType(route, temp) : "main";
}

/**
 * 添加动态(菜单)路由
 * @param {*} menuList 菜单列表
 * @param {*} routes 递归创建的动态(菜单)路由
 */
function fnAddDynamicMenuRoutes(menuList = [], routes = []) {
  var temp = [];
  for (var i = 0; i < menuList.length; i++) {
    if (menuList[i].children && menuList[i].children.length >= 1) {
      temp = temp.concat(menuList[i].children);
    } else if (menuList[i].menuRoute && /\S/.test(menuList[i].menuRoute)) {
      var route = {
        path: menuList[i].menuRoute.replace(".", "-"),
        component: null,
        name: menuList[i].menuRoute.replace(".", "-").replace(/^\//, ""),
        meta: {
          routeName: menuList[i].routeName,
          menuId: menuList[i].id,
          parentId: menuList[i].parentId,
          title: menuList[i].menuTitle,
          isDynamic: true,
          isTab: true,
          iframeUrl: ""
        }
      };
      // 暂时没有这部分内容 暂不处理
      // url以http[s]://开头, 通过iframe展示F
      if (menuList[i].url && isURL(menuList[i].url)) {
        // route['path'] = `i-${menuList[i].menuId}`
        // route['name'] = `i-${menuList[i].menuId}`
        // route['meta']['iframeUrl'] = menuList[i].url
      } else {
        try {
          let path = menuList[i].routeName.replace(".", "/");
          // debugger
          let component = _import(path) || null;
          route["component"] = component;
        } catch (e) {
          console.log("fnAddDynamicMenuRoutes e", e);
        }
      }
      routes.push(route);
    }
  }
  if (temp.length >= 1) {
    fnAddDynamicMenuRoutes(temp, routes);
  } else {
    mainRoutes.name = "main-dynamic";
    mainRoutes.children = routes;
    router.addRoutes([mainRoutes, { path: "*", redirect: { name: "404" } }]);
    sessionStorage.setItem(
      "dynamicMenuRoutes",
      JSON.stringify(mainRoutes.children || "[]")
    );
    console.log("\n");
    console.log(
      "%c!<-------------------- 动态(菜单)路由 s -------------------->",
      "color:blue"
    );
    console.log(mainRoutes.children);
    console.log(
      "%c!<-------------------- 动态(菜单)路由 e -------------------->",
      "color:blue"
    );
  }
}

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js